var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("issues result "),_c('input',{attrs:{"type":"file","name":"image","accept":"image/*","capture":"environment"}})])}]

export { render, staticRenderFns }